var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assessment_main" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.productFlag == 3
      ? _c("ul", [
          _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappds:ds")
            ? _c(
                "li",
                [
                  _c("img", {
                    staticClass: "app_logo",
                    attrs: { src: require("../img/ds-logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "app_bg",
                    attrs: { src: require("../img/znsj-bg.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.entrySys("ds")
                        }
                      }
                    },
                    [_vm._v("进入系统")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assessment_title" }, [
      _c("h2", [_vm._v("社交电商")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a9940a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9940a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/components/socialmall.vue
// module id = null
// module chunks = 